import { apiClient } from "./client";

export interface SessionInfo {
    guest_id: string;
    created: boolean;
    expires_at: string;
}

export async function fetchSession(): Promise<SessionInfo> {
    const { data } = await apiClient.get<SessionInfo>("/session");
    return data;
}
